import clsx from 'clsx';
import Skeleton from 'react-loading-skeleton';
import styles from './Steps.module.scss';

type Props = {
  steps: string[];
  active?: number;
  skeleton?: boolean;
};

const Steps = ({ steps, active, skeleton }: Props): JSX.Element | null => {
  if (!steps?.length) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      {steps.map((step, i) => {
        return (
          <div
            key={i}
            className={clsx(
              styles.step,
              skeleton && styles.stepSkeleton,
              i === 0 && styles.stepFirst,
              i === active && styles.stepActive,
              active && i < active && styles.stepInactive,
              i === steps.length - 1 && styles.stepLast,
            )}
          >
            <span>{skeleton ? <Skeleton width={100} /> : step}</span>
          </div>
        );
      })}
    </div>
  );
};

export default Steps;
